import React from "react"
import styled from "styled-components"
import {Link} from "react-router-dom";
import Layout from "../Layout";
import {Center, PageTitle} from "../shared/mix";
import {Btn, SecondaryBtn} from "../Welcome/WelcomeBanner";
import SEO from "../SEO";

const NotFound = () => {
    return (
        <Layout>
            <SEO
                title="Stránka nenalezena (404)"
                description="Požadovaná stránka na puhony.eu neexistuje."
                noindex
                breadcrumb={false}
            />
            <Center>
                <PageTitle>404</PageTitle>
                <Text>
                    Tahle stránka neexistuje nebo byla přesunuta.
                </Text>
                <Buttons>
                    <Link to="/"><Btn>Na úvod</Btn></Link>
                    <Link to="/sluzby/"><SecondaryBtn>Služby</SecondaryBtn></Link>
                    <Link to="/reference/"><SecondaryBtn>Reference</SecondaryBtn></Link>
                </Buttons>
            </Center>
        </Layout>
    )
}

export default NotFound

const Text = styled.p`
  text-align: center;
  max-width: 34em;
  margin: -1.5em auto 3em;
  font-size: 1.15em;
  line-height: 1.7;
  opacity: 0.55;
  font-weight: 300;
`

const Buttons = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.8em;
  margin-bottom: 6em;

  a {
    text-decoration: none;
  }
`
